import React from 'react';
import { useTranslation } from 'react-i18next';
import { ItemProofOfPaymentModal } from '@/types/modal';
import { NoFooterModal } from '@/components/molecules/common/Modal';
import styles from './Modal.module.scss';
import Grid, { itemList, itemText } from '@/components/molecules/section/Grid';
import { transformDateString } from '@/utilities/datetime';

const ItemProofOfPayment: React.FC<{ modal: ItemProofOfPaymentModal }> = ({ modal }) => {
  const { t } = useTranslation();
  const { item, onClose } = modal;

  const items = [
    itemText(t('item.seller_payment.payment_amount'), item.netSellingPrice),
    itemText(t('item.seller_payment.account_type'), item.productSellerPayout.accountType),
    itemText(t('item.seller_payment.bank_name'), item.productSellerPayout.bankName),
    itemText(t('item.seller_payment.account_detail'), item.productSellerPayout.accountDetail),
    itemText(
      t('item.seller_payment.date_of_seller_transfer'),
      item.sellerTransferDade === '0000-00-00 00:00:00' ? 'N/A' : transformDateString(item.sellerTransferDade),
    ),
    itemList(
      t('item.seller_payment.split_payment_status'),
      item.productSellerPayout.splitPaymentStatuses?.length ? item.productSellerPayout.splitPaymentStatuses : null,
    ),
  ];

  const body = (
    <div className={styles.itemProofOfPayment}>
      <div className={styles.text1rem}>{`${t('common.item')} #${item.productId}`}</div>
      <div className={styles.text1rem}>{item.brandName}</div>
      <div className={styles.text1rem}>{item.productName}</div>

      <div className={styles.itemProofOfPaymentTable}>
        <Grid
          column={4}
          items={items}
        />
      </div>
    </div>
  );

  return (
    <NoFooterModal
      title={t('item.seller_payment.proofOfPayment.title')}
      onClose={onClose}
      body={body}
      containerStyle={{ width: 700 }}
      modalName="item_proof_of_payment"
    />
  );
};

export default ItemProofOfPayment;
